export default from './demo-confirmation';



// WEBPACK FOOTER //
// ./app/components/demo-confirmation/index.js